import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/warning_sign.svg'


const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Você pode criar gerar códigos para valores personalizados. ", -1)
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between py-4 border-bottom" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted mb-0" }, "Valor atual", -1)
const _hoisted_5 = { class: "text-paragraph mb-0" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between py-4 border-bottom" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted mb-0" }, "Desconto", -1)
const _hoisted_8 = { class: "text-paragraph mb-0" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between py-4 border-bottom" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted mb-0" }, "Valor final", -1)
const _hoisted_11 = { class: "text-paragraph mb-0" }
const _hoisted_12 = { class: "border-bottom py-4" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-0" }, "Código terá data de validade?", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted" }, " Quando esta opção estiver ativa, seu código só funcionará até a data informada. ", -1)
const _hoisted_16 = { class: "border-bottom py-4 mb-4" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-0" }, "Limite de uso por paciente?", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted" }, " Quando esta opção estiver ativa, este código só poderá ser utilizado por um mesmo paciente a quantidade de vezes informado abaixo. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "border p-4 rounded-4 d-flex mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "me-4"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, [
    /*#__PURE__*/_createTextVNode(" Lembramos que assim que um código é criado, "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle" }, "não será possível editar"),
    /*#__PURE__*/_createTextVNode(" as informações posteriormente. ")
  ])
], -1)

import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import moment from "moment";
import { useVeeField } from "@/composables/useVeeField";
import { buildAddCouponSchema } from "@/schemas/coupon";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleOffcanvas } from "@/utils/Helper";
import { MINIMUM_APPOINTMENT_PRICE } from "@/constants";
import { useCreateCoupon } from "@/composables/useCoupons";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCoupon',
  setup(__props) {

const { session } = useSessionStore();
const minimumPrice = MINIMUM_APPOINTMENT_PRICE;
const sessionValue = (session?.appointment_price as any) || 0;

const currentPrice = (session?.appointment_price as any)?.toCurrency?.() ?? "";
const percentOff = ref("");
const limitValue = ref("");
const redeemByPlaceholder = moment().add(90, "days").format("DD/MM/YYYY");

const { handleSubmit, meta, resetField } = useForm({
  validationSchema: toTypedSchema(
    buildAddCouponSchema(minimumPrice, sessionValue),
  ),
  initialValues: {
    code: "",
    percent_off: "",
    has_redemption: false,
    has_limit: false,
    redeem_by: "",
    max_redemptions_customers: "",
  },
});

const codeModel = useVeeField("code");
const percentOffModel = useVeeField("percent_off");
const hasRedemptionModel = useVeeField<boolean>("has_redemption");
const hasLimitModel = useVeeField<boolean>("has_limit");
const redeemByModel = useVeeField("redeem_by");
const maxRedemptionsCustomersModel = useVeeField("max_redemptions_customers");

const discount = computed(() => {
  const percent = parseInt(percentOffModel.$model);
  if (!percent) return "R$0,00";
  const disc = (percent / 100) * sessionValue;
  return disc > 0 ? (disc as any).toCurrency() : "R$0,00";
});

const newPrice = computed(() => {
  const percent = parseInt(percentOffModel.$model);
  if (!percent) return (sessionValue as any)?.toCurrency?.() ?? "";
  const disc = (percent / 100) * sessionValue;
  const vwd = sessionValue - disc;
  return vwd > 0
    ? (vwd as any).toCurrency()
    : (sessionValue as any)?.toCurrency?.() ?? "";
});

const { mutateAsync: createCoupon, isPending: submitting } = useCreateCoupon();

function handlePercentOff(event: any) {
  let text = event.target.value;
  let t = (text as any).clear();
  if (t && t.length > 2) return;
  if (percentOff.value.length > text.length) {
    t = text.substring(0, text.length - 1);
  }
  percentOff.value = (t as any).toPercentage();
  percentOffModel.$model = (t as any).toPercentage();
}

function handleLimit(event: any) {
  let text = event.target.value;
  let t = text.replace("x", "");
  if (t && t.length > 3) return;
  if (limitValue.value.length > text.length) {
    t = text.substring(0, text.length - 1);
  }
  limitValue.value = (t as any).toQuantity();
  maxRedemptionsCustomersModel.$model = (t as any).toQuantity();
}

const onSubmit = handleSubmit(async (values) => {
  try {
    await createCoupon({
      code: values.code,
      percent_off: values.percent_off,
      ...(values.has_redemption && { redeem_by: values.redeem_by }),
      ...(values.has_limit && {
        max_redemptions_customers: values.max_redemptions_customers,
      }),
    });
    toggleOffcanvas("offcanvas_views");
    useOffcanvasStore().clear();
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Sucesso",
      msg: "Código criado com sucesso",
    });
  } catch (error: any) {
    alert(error.message || "Ocorreu um erro no servidor");
  }
});

function handleHasRedemption(event: any) {
  if (!event.target.checked) {
    resetField("redeem_by", { value: "" });
  }
}

function handleHasLimit(event: any) {
  if (!event.target.checked) {
    resetField("max_redemptions_customers", { value: "" });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SwitchInput = _resolveComponent("SwitchInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TextInput, {
      required: "",
      label: "Código",
      model: _unref(codeModel),
      type: "text",
      placeholder: `${_unref(session)?.name.split(' ')[0].toUpperCase()}10`,
      onInput: _cache[0] || (_cache[0] = (event) => (_unref(codeModel).$model = (event.target as HTMLInputElement).value.toUpperCase()))
    }, null, 8, ["model", "placeholder"]),
    _createVNode(_component_TextInput, {
      required: "",
      label: "Desconto do código",
      model: _unref(percentOffModel),
      type: "text",
      placeholder: "10%",
      onInput: handlePercentOff,
      maxLength: 3
    }, null, 8, ["model"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(currentPrice)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, _toDisplayString(discount.value), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("p", _hoisted_11, _toDisplayString(newPrice.value), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_SwitchInput, {
          model: _unref(hasRedemptionModel),
          id: "hasRedemption",
          color: "secondary",
          onHandleChange: handleHasRedemption
        }, null, 8, ["model"])
      ]),
      _hoisted_15,
      (_unref(hasRedemptionModel).$model)
        ? (_openBlock(), _createBlock(_component_TextInput, {
            key: 0,
            required: "",
            model: _unref(redeemByModel),
            type: "text",
            placeholder: _unref(redeemByPlaceholder),
            class: "mb-0 pb-0",
            mask: '##/##/####'
          }, null, 8, ["model", "placeholder"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_SwitchInput, {
          model: _unref(hasLimitModel),
          id: "hasLimit",
          color: "secondary",
          onHandleChange: handleHasLimit
        }, null, 8, ["model"])
      ]),
      _hoisted_19,
      (_unref(hasLimitModel).$model)
        ? (_openBlock(), _createBlock(_component_TextInput, {
            key: 0,
            required: "",
            model: _unref(maxRedemptionsCustomersModel),
            placeholder: "1x",
            class: "mb-0 pb-0"
          }, null, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_20,
    _createVNode(_component_FormButton, {
      label: "Criar código",
      loading: _unref(submitting),
      disabled: !_unref(meta).valid,
      class: "mb-3",
      onOnClick: _unref(onSubmit)
    }, null, 8, ["loading", "disabled", "onOnClick"])
  ]))
}
}

})